var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"direction":"horizontal"}},[_c('el-aside',{attrs:{"width":"200px"}},[_vm._t("menuList")],2),_c('el-container',{staticClass:"main",attrs:{"direction":"vertical"}},[_c('el-main',{staticStyle:{"padding":"0"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }